export type VehicleCatalogueEnumOption<
  P = {
    name: string;
    value: unknown;
  },
> = {
  value: string;
  label: string;
  shortLabel?: string | null;
  categories?: Array<
    | {
        value: string;
        label: string;
        shortLabel: string;
      }
    | string
  >;
  properties?: Array<Partial<P>>;
  children?: Array<VehicleCatalogueEnumOption>;
};
